// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersHeader-module__font-s-10___Da7y0 {
  font-size: 10px !important;
}

.FiltersHeader-module__font-s-12___vuHP6 {
  font-size: 12px !important;
}

.FiltersHeader-module__font-s-13___Nj3Q8 {
  font-size: 13px !important;
}

.FiltersHeader-module__font-s-14___dkqXN {
  font-size: 14px !important;
}

.FiltersHeader-module__font-s-15___aEVCM {
  font-size: 15px !important;
}

.FiltersHeader-module__font-s-16___haIJp {
  font-size: 16px !important;
}

.FiltersHeader-module__font-s-18___nEBSf {
  font-size: 18px !important;
}

.FiltersHeader-module__font-s-20___XCzPw {
  font-size: 20px !important;
}

.FiltersHeader-module__font-s-22___V_y3M {
  font-size: 22px !important;
}

.FiltersHeader-module__font-s-28___XUaSw {
  font-size: 28px !important;
}

.FiltersHeader-module__font-w-400____hajt {
  font-weight: 400 !important;
}

.FiltersHeader-module__font-w-500___KjgWc {
  font-weight: 500 !important;
}

.FiltersHeader-module__font-w-600___QgLTC {
  font-weight: 600 !important;
}

.FiltersHeader-module__font-w-700___xe3NA {
  font-weight: 700 !important;
}

.FiltersHeader-module__p-5___K2QTI {
  padding: 5px !important;
}

.FiltersHeader-module__p-12___lPMOg {
  padding: 12px !important;
}

.FiltersHeader-module__p-16___aYvcx {
  padding: 16px !important;
}

.FiltersHeader-module__p-30___lhaCR {
  padding: 30px !important;
}

.FiltersHeader-module__p-b-0___SFTwN {
  padding-bottom: 0 !important;
}

.FiltersHeader-module__p-b-5___WKdOM {
  padding-bottom: 5px !important;
}

.FiltersHeader-module__p-b-10___snTur {
  padding-bottom: 10px !important;
}

.FiltersHeader-module__p-b-12___eJ6tt {
  padding-bottom: 12px !important;
}

.FiltersHeader-module__p-b-16___SyyTl {
  padding-bottom: 16px !important;
}

.FiltersHeader-module__p-b-18___LsRBG {
  padding-bottom: 18px !important;
}

.FiltersHeader-module__p-b-20___sNBOh {
  padding-bottom: 20px !important;
}

.FiltersHeader-module__p-b-25___BjIJe {
  padding-bottom: 25px !important;
}

.FiltersHeader-module__p-b-30___J9aqW {
  padding-bottom: 30px !important;
}

.FiltersHeader-module__p-b-50___mk3og {
  padding-bottom: 50px !important;
}

.FiltersHeader-module__p-t-0___BPok1 {
  padding-top: 0 !important;
}

.FiltersHeader-module__p-t-12___GF6mN {
  padding-top: 12px !important;
}

.FiltersHeader-module__p-t-16___BCuQQ {
  padding-top: 16px !important;
}

.FiltersHeader-module__p-t-18___VLl_T {
  padding-top: 18px !important;
}

.FiltersHeader-module__p-t-20___lKPDL {
  padding-top: 20px !important;
}

.FiltersHeader-module__p-t-30___T1bc2 {
  padding-top: 30px !important;
}

.FiltersHeader-module__p-t-40___f_lZD {
  padding-top: 40px !important;
}

.FiltersHeader-module__p-t-50___v4tnp {
  padding-top: 50px !important;
}

.FiltersHeader-module__p-l-20___R2XpK {
  padding-left: 20px !important;
}

.FiltersHeader-module__p-l-30___pq__F {
  padding-left: 30px !important;
}

.FiltersHeader-module__p-l-40___CkIWq {
  padding-left: 40px !important;
}

.FiltersHeader-module__p-r-16___x_c6O {
  padding-right: 16px !important;
}

.FiltersHeader-module__p-r-20___URqzk {
  padding-right: 20px !important;
}

.FiltersHeader-module__p-r-30___SHmkC {
  padding-right: 30px !important;
}

.FiltersHeader-module__p-r-50___vAog_ {
  padding-right: 50px !important;
}

.FiltersHeader-module__p-r-60___bvOc6 {
  padding-right: 60px !important;
}

.FiltersHeader-module__m-b-1___QlP76 {
  margin-bottom: 1px !important;
}

.FiltersHeader-module__m-b-2___EpzhT {
  margin-bottom: 2px !important;
}

.FiltersHeader-module__m-b-6___atG5v {
  margin-bottom: 6px !important;
}

.FiltersHeader-module__m-b-8___z_DpR {
  margin-bottom: 8px !important;
}

.FiltersHeader-module__m-b-10___XsCL0 {
  margin-bottom: 10px !important;
}

.FiltersHeader-module__m-b-14___Abxta {
  margin-bottom: 14px !important;
}

.FiltersHeader-module__m-b-16___iIzEL {
  margin-bottom: 16px !important;
}

.FiltersHeader-module__m-b-20___rqtG0 {
  margin-bottom: 20px !important;
}

.FiltersHeader-module__m-b-22___HJpZd {
  margin-bottom: 22px !important;
}

.FiltersHeader-module__m-b-24___y2UJQ {
  margin-bottom: 24px !important;
}

.FiltersHeader-module__m-b-30___qrJl1 {
  margin-bottom: 30px !important;
}

.FiltersHeader-module__m-b-32___PwMeL {
  margin-bottom: 32px !important;
}

.FiltersHeader-module__m-b-40___hRoIG {
  margin-bottom: 40px !important;
}

.FiltersHeader-module__m-t-2___uEFVu {
  margin-top: 2px !important;
}

.FiltersHeader-module__m-t-3___J1GWO {
  margin-top: 3px !important;
}

.FiltersHeader-module__m-t-4___C_E6f {
  margin-top: 4px !important;
}

.FiltersHeader-module__m-t-5___U_oTL {
  margin-top: 5px !important;
}

.FiltersHeader-module__m-t-8___Qn1Wb {
  margin-top: 8px !important;
}

.FiltersHeader-module__m-t-10___BOZUb {
  margin-top: 10px !important;
}

.FiltersHeader-module__m-t-15___D94mg {
  margin-top: 15px !important;
}

.FiltersHeader-module__m-t-16___eS8f_ {
  margin-top: 16px !important;
}

.FiltersHeader-module__m-t-20___u4nVa {
  margin-top: 20px !important;
}

.FiltersHeader-module__m-t-22___Ty6oK {
  margin-top: 22px !important;
}

.FiltersHeader-module__m-t-30___avBQh {
  margin-top: 30px !important;
}

.FiltersHeader-module__m-t-32___sjrg9 {
  margin-top: 32px !important;
}

.FiltersHeader-module__m-l-auto___X69Qv {
  margin-left: auto !important;
}

.FiltersHeader-module__m-l-4___NUQH0 {
  margin-left: 4px !important;
}

.FiltersHeader-module__m-l-5___hmiW6 {
  margin-left: 5px !important;
}

.FiltersHeader-module__m-l-6___qeC_E {
  margin-left: 6px !important;
}

.FiltersHeader-module__m-l-8___vnw1O {
  margin-left: 8px !important;
}

.FiltersHeader-module__m-l-10___WFZmD {
  margin-left: 10px !important;
}

.FiltersHeader-module__m-l-16___tSCkg {
  margin-left: 16px !important;
}

.FiltersHeader-module__m-l-20___g621N {
  margin-left: 20px !important;
}

.FiltersHeader-module__m-l-24___Ag4zD {
  margin-left: 24px !important;
}

.FiltersHeader-module__m-l-30___A3uXi {
  margin-left: 30px !important;
}

.FiltersHeader-module__m-l-35___EZgfX {
  margin-left: 35px !important;
}

.FiltersHeader-module__m-l-40___g0wGM {
  margin-left: 40px !important;
}

.FiltersHeader-module__m-r-8___FUzry {
  margin-right: 8px !important;
}

.FiltersHeader-module__m-r-10___BTCPm {
  margin-right: 10px !important;
}

.FiltersHeader-module__m-r-16___kZnGg {
  margin-right: 16px !important;
}

.FiltersHeader-module__m-r-20___B3WCu {
  margin-right: 20px !important;
}

.FiltersHeader-module__m-r-24___hAKD0 {
  margin-right: 24px !important;
}

.FiltersHeader-module__m-r-30___OlYEC {
  margin-right: 30px !important;
}

.FiltersHeader-module__m-r-40___rAMfb {
  margin-right: 40px !important;
}

.FiltersHeader-module__border-r-3___gOF62 {
  border-radius: 3px !important;
}

.FiltersHeader-module__border-r-4___CUaiC {
  border-radius: 4px !important;
}

.FiltersHeader-module__border-r-6___poUT2 {
  border-radius: 6px !important;
}

.FiltersHeader-module__border-r-10___bu6ac {
  border-radius: 10px !important;
}

.FiltersHeader-module__border-r-12___etcM5 {
  border-radius: 12px !important;
}

.FiltersHeader-module__border-r-16___scj1C {
  border-radius: 16px !important;
}

.FiltersHeader-module__border-r-50___YyJsV {
  border-radius: 50% !important;
}

.FiltersHeader-module__primary-border___oPjNm {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FiltersHeader-module__primary-border-b___OH7tG {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FiltersHeader-module__primary-border-t___dDdp8 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FiltersHeader-module__primary-border-l___P6mt2 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FiltersHeader-module__primary-border-r___zSFPw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FiltersHeader-module__secondary-border___xFFJd {
  border: 1px solid #637768;
}

.FiltersHeader-module__secondary-border-b___tGjW8 {
  border-bottom: 1px solid #637768;
}

.FiltersHeader-module__secondary-border-t___N2DuH {
  border-top: 1px solid #637768;
}

.FiltersHeader-module__secondary-border-l___hKo5s {
  border-left: 1px solid #637768;
}

.FiltersHeader-module__secondary-border-r___u1sP0 {
  border-right: 1px solid #637768;
}

.FiltersHeader-module__gap-0___qgZdK {
  gap: 0 !important;
}

.FiltersHeader-module__gap-2___j_aUL {
  gap: 2px !important;
}

.FiltersHeader-module__gap-4___qfnOZ {
  gap: 4px !important;
}

.FiltersHeader-module__gap-5___bs1fW {
  gap: 5px !important;
}

.FiltersHeader-module__gap-6___aiMmC {
  gap: 6px !important;
}

.FiltersHeader-module__gap-8___rC8_r {
  gap: 8px !important;
}

.FiltersHeader-module__gap-10___gmuLw {
  gap: 10px !important;
}

.FiltersHeader-module__gap-12___sEAC7 {
  gap: 12px !important;
}

.FiltersHeader-module__gap-14___TFk6D {
  gap: 14px !important;
}

.FiltersHeader-module__gap-16___rKiDi {
  gap: 16px !important;
}

.FiltersHeader-module__gap-18___HS9Oj {
  gap: 18px !important;
}

.FiltersHeader-module__gap-20___fGmrO {
  gap: 20px !important;
}

.FiltersHeader-module__gap-24___LIIbs {
  gap: 24px !important;
}

.FiltersHeader-module__gap-26___KmTmk {
  gap: 26px !important;
}

.FiltersHeader-module__gap-30___zcl1x {
  gap: 30px !important;
}

.FiltersHeader-module__gap-32___oazRS {
  gap: 32px !important;
}

.FiltersHeader-module__gap-40___QQH_3 {
  gap: 40px !important;
}

.FiltersHeader-module__gap-50___SZxCy {
  gap: 50px !important;
}

.FiltersHeader-module__flex-1___EWTVo {
  flex: 1;
}

.FiltersHeader-module__flex-none___wSDzZ {
  flex: none !important;
}

.FiltersHeader-module__flex-column____yrsI {
  display: flex;
  flex-direction: column !important;
}

.FiltersHeader-module__flex-row___HMSu6 {
  display: flex;
  flex-direction: row !important;
}

.FiltersHeader-module__vertically-centered___Lgn8U {
  display: flex;
  align-items: center !important;
}

.FiltersHeader-module__horizontally-centered___b9WcP {
  display: flex;
  justify-content: center !important;
}

.FiltersHeader-module__horizontally-end___md9j2 {
  display: flex;
  justify-content: end !important;
}

.FiltersHeader-module__vertically-start___moYOT {
  display: flex;
  align-items: start !important;
}

.FiltersHeader-module__space-between___gpdfV {
  display: flex;
  justify-content: space-between !important;
}

.FiltersHeader-module__flex-wrap___e0kJw {
  flex-wrap: wrap !important;
}

.FiltersHeader-module__height-100___Nn9LY {
  height: 100%;
}

.FiltersHeader-module__width-50___lkR0T {
  width: 50% !important;
}

.FiltersHeader-module__width-100___fs08R {
  width: 100%;
}

.FiltersHeader-module__cursor-pointer___L_JyH {
  cursor: pointer;
}

.FiltersHeader-module__cursor-not-allowed___r5HYj {
  cursor: not-allowed !important;
}

.FiltersHeader-module__absolute-centered___nFeL8 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FiltersHeader-module__absolute___GihPd {
  position: absolute;
}

.FiltersHeader-module__relative___p1STJ {
  position: relative;
}

.FiltersHeader-module__fixed___VxhwZ {
  position: fixed;
}

.FiltersHeader-module__visible___d7jgW {
  opacity: 1;
}

.FiltersHeader-module__invisible___P0rgu {
  opacity: 0;
}

.FiltersHeader-module__col-90___FIy_y {
  width: 90% !important;
}

.FiltersHeader-module__col-auto___qMMiA {
  width: auto !important;
}

.FiltersHeader-module__medical-tabs___a5cpO {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FiltersHeader-module__medical-table-new___xgopQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FiltersHeader-module__medical-table-new___xgopQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FiltersHeader-module__medical-table-new___xgopQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FiltersHeader-module__medical-table-new___xgopQ::-webkit-scrollbar-track {
  display: none;
}
.FiltersHeader-module__medical-table-new___xgopQ.FiltersHeader-module__no-pagination___rmR2G {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FiltersHeader-module__medical-table-new___xgopQ.FiltersHeader-module__no-pagination___rmR2G:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FiltersHeader-module__medical-table-new___xgopQ.FiltersHeader-module__no-pagination___rmR2G::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FiltersHeader-module__medical-table-new___xgopQ.FiltersHeader-module__no-pagination___rmR2G::-webkit-scrollbar-track {
  display: none;
}

.FiltersHeader-module__medical-table-empty___SvB_L {
  padding: 14px 40px !important;
}

.FiltersHeader-module__icon-btn___NdRzO {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FiltersHeader-module__search-icon___kYrDV {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FiltersHeader-module__disable-select___WZmHy {
  user-select: none;
}

.FiltersHeader-module__break-word___O2HT9 {
  word-break: break-word;
}

.FiltersHeader-module__popup-clear-btn___oBq0a {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FiltersHeader-module__scroll-m-b-20___aqaaL {
  scroll-margin-bottom: 20px;
}

.FiltersHeader-module__container___cupE2 {
  background-color: #fbf7f2;
  padding: 24px 40px;
}
.FiltersHeader-module__container___cupE2 .FiltersHeader-module__title___UH_Iq {
  color: #375844;
  width: 170px;
}
.FiltersHeader-module__container___cupE2 .FiltersHeader-module__filters___zj4Xk {
  width: 80%;
}
.FiltersHeader-module__container___cupE2 .FiltersHeader-module__filters___zj4Xk > * {
  background-color: white;
  box-sizing: border-box;
  white-space: nowrap;
  min-width: 250px;
  margin-bottom: 0;
  height: 40px;
  flex: 1;
}
.FiltersHeader-module__container___cupE2 .FiltersHeader-module__filters___zj4Xk .FiltersHeader-module__picker___I34OC {
  min-width: 30%;
  background-color: transparent;
}
.FiltersHeader-module__container___cupE2 .FiltersHeader-module__filters___zj4Xk .FiltersHeader-module__picker___I34OC .FiltersHeader-module__input___S2nAb {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Labs/headers/FiltersHeader/FiltersHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,UAAA;AA6pBJ;AA3pBI;EACE,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;AA6pBN;AA1pBI;EACE,cAAA;EACA,6BAAA;AA4pBN;AA1pBM;EACE,uBAAA;AA4pBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(orangeNew, light);\n  padding: 24px 40px;\n\n  .title {\n    color: get-color(greenNew, dark);\n    width: 170px;\n  }\n\n  .filters {\n    width: 80%;\n\n    & > * {\n      background-color: get-color(white);\n      box-sizing: border-box;\n      white-space: nowrap;\n      min-width: 250px;\n      margin-bottom: 0;\n      height: 40px;\n      flex: 1;\n    }\n\n    .picker {\n      min-width: 30%;\n      background-color: transparent;\n\n      .input {\n        background-color: get-color(white);\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FiltersHeader-module__font-s-10___Da7y0`,
	"fontS12": `FiltersHeader-module__font-s-12___vuHP6`,
	"fontS13": `FiltersHeader-module__font-s-13___Nj3Q8`,
	"fontS14": `FiltersHeader-module__font-s-14___dkqXN`,
	"fontS15": `FiltersHeader-module__font-s-15___aEVCM`,
	"fontS16": `FiltersHeader-module__font-s-16___haIJp`,
	"fontS18": `FiltersHeader-module__font-s-18___nEBSf`,
	"fontS20": `FiltersHeader-module__font-s-20___XCzPw`,
	"fontS22": `FiltersHeader-module__font-s-22___V_y3M`,
	"fontS28": `FiltersHeader-module__font-s-28___XUaSw`,
	"fontW400": `FiltersHeader-module__font-w-400____hajt`,
	"fontW500": `FiltersHeader-module__font-w-500___KjgWc`,
	"fontW600": `FiltersHeader-module__font-w-600___QgLTC`,
	"fontW700": `FiltersHeader-module__font-w-700___xe3NA`,
	"p5": `FiltersHeader-module__p-5___K2QTI`,
	"p12": `FiltersHeader-module__p-12___lPMOg`,
	"p16": `FiltersHeader-module__p-16___aYvcx`,
	"p30": `FiltersHeader-module__p-30___lhaCR`,
	"pB0": `FiltersHeader-module__p-b-0___SFTwN`,
	"pB5": `FiltersHeader-module__p-b-5___WKdOM`,
	"pB10": `FiltersHeader-module__p-b-10___snTur`,
	"pB12": `FiltersHeader-module__p-b-12___eJ6tt`,
	"pB16": `FiltersHeader-module__p-b-16___SyyTl`,
	"pB18": `FiltersHeader-module__p-b-18___LsRBG`,
	"pB20": `FiltersHeader-module__p-b-20___sNBOh`,
	"pB25": `FiltersHeader-module__p-b-25___BjIJe`,
	"pB30": `FiltersHeader-module__p-b-30___J9aqW`,
	"pB50": `FiltersHeader-module__p-b-50___mk3og`,
	"pT0": `FiltersHeader-module__p-t-0___BPok1`,
	"pT12": `FiltersHeader-module__p-t-12___GF6mN`,
	"pT16": `FiltersHeader-module__p-t-16___BCuQQ`,
	"pT18": `FiltersHeader-module__p-t-18___VLl_T`,
	"pT20": `FiltersHeader-module__p-t-20___lKPDL`,
	"pT30": `FiltersHeader-module__p-t-30___T1bc2`,
	"pT40": `FiltersHeader-module__p-t-40___f_lZD`,
	"pT50": `FiltersHeader-module__p-t-50___v4tnp`,
	"pL20": `FiltersHeader-module__p-l-20___R2XpK`,
	"pL30": `FiltersHeader-module__p-l-30___pq__F`,
	"pL40": `FiltersHeader-module__p-l-40___CkIWq`,
	"pR16": `FiltersHeader-module__p-r-16___x_c6O`,
	"pR20": `FiltersHeader-module__p-r-20___URqzk`,
	"pR30": `FiltersHeader-module__p-r-30___SHmkC`,
	"pR50": `FiltersHeader-module__p-r-50___vAog_`,
	"pR60": `FiltersHeader-module__p-r-60___bvOc6`,
	"mB1": `FiltersHeader-module__m-b-1___QlP76`,
	"mB2": `FiltersHeader-module__m-b-2___EpzhT`,
	"mB6": `FiltersHeader-module__m-b-6___atG5v`,
	"mB8": `FiltersHeader-module__m-b-8___z_DpR`,
	"mB10": `FiltersHeader-module__m-b-10___XsCL0`,
	"mB14": `FiltersHeader-module__m-b-14___Abxta`,
	"mB16": `FiltersHeader-module__m-b-16___iIzEL`,
	"mB20": `FiltersHeader-module__m-b-20___rqtG0`,
	"mB22": `FiltersHeader-module__m-b-22___HJpZd`,
	"mB24": `FiltersHeader-module__m-b-24___y2UJQ`,
	"mB30": `FiltersHeader-module__m-b-30___qrJl1`,
	"mB32": `FiltersHeader-module__m-b-32___PwMeL`,
	"mB40": `FiltersHeader-module__m-b-40___hRoIG`,
	"mT2": `FiltersHeader-module__m-t-2___uEFVu`,
	"mT3": `FiltersHeader-module__m-t-3___J1GWO`,
	"mT4": `FiltersHeader-module__m-t-4___C_E6f`,
	"mT5": `FiltersHeader-module__m-t-5___U_oTL`,
	"mT8": `FiltersHeader-module__m-t-8___Qn1Wb`,
	"mT10": `FiltersHeader-module__m-t-10___BOZUb`,
	"mT15": `FiltersHeader-module__m-t-15___D94mg`,
	"mT16": `FiltersHeader-module__m-t-16___eS8f_`,
	"mT20": `FiltersHeader-module__m-t-20___u4nVa`,
	"mT22": `FiltersHeader-module__m-t-22___Ty6oK`,
	"mT30": `FiltersHeader-module__m-t-30___avBQh`,
	"mT32": `FiltersHeader-module__m-t-32___sjrg9`,
	"mLAuto": `FiltersHeader-module__m-l-auto___X69Qv`,
	"mL4": `FiltersHeader-module__m-l-4___NUQH0`,
	"mL5": `FiltersHeader-module__m-l-5___hmiW6`,
	"mL6": `FiltersHeader-module__m-l-6___qeC_E`,
	"mL8": `FiltersHeader-module__m-l-8___vnw1O`,
	"mL10": `FiltersHeader-module__m-l-10___WFZmD`,
	"mL16": `FiltersHeader-module__m-l-16___tSCkg`,
	"mL20": `FiltersHeader-module__m-l-20___g621N`,
	"mL24": `FiltersHeader-module__m-l-24___Ag4zD`,
	"mL30": `FiltersHeader-module__m-l-30___A3uXi`,
	"mL35": `FiltersHeader-module__m-l-35___EZgfX`,
	"mL40": `FiltersHeader-module__m-l-40___g0wGM`,
	"mR8": `FiltersHeader-module__m-r-8___FUzry`,
	"mR10": `FiltersHeader-module__m-r-10___BTCPm`,
	"mR16": `FiltersHeader-module__m-r-16___kZnGg`,
	"mR20": `FiltersHeader-module__m-r-20___B3WCu`,
	"mR24": `FiltersHeader-module__m-r-24___hAKD0`,
	"mR30": `FiltersHeader-module__m-r-30___OlYEC`,
	"mR40": `FiltersHeader-module__m-r-40___rAMfb`,
	"borderR3": `FiltersHeader-module__border-r-3___gOF62`,
	"borderR4": `FiltersHeader-module__border-r-4___CUaiC`,
	"borderR6": `FiltersHeader-module__border-r-6___poUT2`,
	"borderR10": `FiltersHeader-module__border-r-10___bu6ac`,
	"borderR12": `FiltersHeader-module__border-r-12___etcM5`,
	"borderR16": `FiltersHeader-module__border-r-16___scj1C`,
	"borderR50": `FiltersHeader-module__border-r-50___YyJsV`,
	"primaryBorder": `FiltersHeader-module__primary-border___oPjNm`,
	"primaryBorderB": `FiltersHeader-module__primary-border-b___OH7tG`,
	"primaryBorderT": `FiltersHeader-module__primary-border-t___dDdp8`,
	"primaryBorderL": `FiltersHeader-module__primary-border-l___P6mt2`,
	"primaryBorderR": `FiltersHeader-module__primary-border-r___zSFPw`,
	"secondaryBorder": `FiltersHeader-module__secondary-border___xFFJd`,
	"secondaryBorderB": `FiltersHeader-module__secondary-border-b___tGjW8`,
	"secondaryBorderT": `FiltersHeader-module__secondary-border-t___N2DuH`,
	"secondaryBorderL": `FiltersHeader-module__secondary-border-l___hKo5s`,
	"secondaryBorderR": `FiltersHeader-module__secondary-border-r___u1sP0`,
	"gap0": `FiltersHeader-module__gap-0___qgZdK`,
	"gap2": `FiltersHeader-module__gap-2___j_aUL`,
	"gap4": `FiltersHeader-module__gap-4___qfnOZ`,
	"gap5": `FiltersHeader-module__gap-5___bs1fW`,
	"gap6": `FiltersHeader-module__gap-6___aiMmC`,
	"gap8": `FiltersHeader-module__gap-8___rC8_r`,
	"gap10": `FiltersHeader-module__gap-10___gmuLw`,
	"gap12": `FiltersHeader-module__gap-12___sEAC7`,
	"gap14": `FiltersHeader-module__gap-14___TFk6D`,
	"gap16": `FiltersHeader-module__gap-16___rKiDi`,
	"gap18": `FiltersHeader-module__gap-18___HS9Oj`,
	"gap20": `FiltersHeader-module__gap-20___fGmrO`,
	"gap24": `FiltersHeader-module__gap-24___LIIbs`,
	"gap26": `FiltersHeader-module__gap-26___KmTmk`,
	"gap30": `FiltersHeader-module__gap-30___zcl1x`,
	"gap32": `FiltersHeader-module__gap-32___oazRS`,
	"gap40": `FiltersHeader-module__gap-40___QQH_3`,
	"gap50": `FiltersHeader-module__gap-50___SZxCy`,
	"flex1": `FiltersHeader-module__flex-1___EWTVo`,
	"flexNone": `FiltersHeader-module__flex-none___wSDzZ`,
	"flexColumn": `FiltersHeader-module__flex-column____yrsI`,
	"flexRow": `FiltersHeader-module__flex-row___HMSu6`,
	"verticallyCentered": `FiltersHeader-module__vertically-centered___Lgn8U`,
	"horizontallyCentered": `FiltersHeader-module__horizontally-centered___b9WcP`,
	"horizontallyEnd": `FiltersHeader-module__horizontally-end___md9j2`,
	"verticallyStart": `FiltersHeader-module__vertically-start___moYOT`,
	"spaceBetween": `FiltersHeader-module__space-between___gpdfV`,
	"flexWrap": `FiltersHeader-module__flex-wrap___e0kJw`,
	"height100": `FiltersHeader-module__height-100___Nn9LY`,
	"width50": `FiltersHeader-module__width-50___lkR0T`,
	"width100": `FiltersHeader-module__width-100___fs08R`,
	"cursorPointer": `FiltersHeader-module__cursor-pointer___L_JyH`,
	"cursorNotAllowed": `FiltersHeader-module__cursor-not-allowed___r5HYj`,
	"absoluteCentered": `FiltersHeader-module__absolute-centered___nFeL8`,
	"absolute": `FiltersHeader-module__absolute___GihPd`,
	"relative": `FiltersHeader-module__relative___p1STJ`,
	"fixed": `FiltersHeader-module__fixed___VxhwZ`,
	"visible": `FiltersHeader-module__visible___d7jgW`,
	"invisible": `FiltersHeader-module__invisible___P0rgu`,
	"col90": `FiltersHeader-module__col-90___FIy_y`,
	"colAuto": `FiltersHeader-module__col-auto___qMMiA`,
	"medicalTabs": `FiltersHeader-module__medical-tabs___a5cpO`,
	"medicalTableNew": `FiltersHeader-module__medical-table-new___xgopQ`,
	"noPagination": `FiltersHeader-module__no-pagination___rmR2G`,
	"medicalTableEmpty": `FiltersHeader-module__medical-table-empty___SvB_L`,
	"iconBtn": `FiltersHeader-module__icon-btn___NdRzO`,
	"searchIcon": `FiltersHeader-module__search-icon___kYrDV`,
	"disableSelect": `FiltersHeader-module__disable-select___WZmHy`,
	"breakWord": `FiltersHeader-module__break-word___O2HT9`,
	"popupClearBtn": `FiltersHeader-module__popup-clear-btn___oBq0a`,
	"scrollMB20": `FiltersHeader-module__scroll-m-b-20___aqaaL`,
	"container": `FiltersHeader-module__container___cupE2`,
	"title": `FiltersHeader-module__title___UH_Iq`,
	"filters": `FiltersHeader-module__filters___zj4Xk`,
	"picker": `FiltersHeader-module__picker___I34OC`,
	"input": `FiltersHeader-module__input___S2nAb`
};
module.exports = ___CSS_LOADER_EXPORT___;
